import { isEmpty } from 'ramda';
import * as React from 'react';
import { useSelector } from 'react-redux';

import {
  selectFiltersStringified,
  selectOffersHistoryData,
  selectOffersHistorySpoilerData,
  selectViewedOffers,
} from '../../../selectors/offersHistory';
import { OffersFeed, Error, EmptyData } from '../components';
import { Loading } from '../components/commonComponents';
import { IOffersFeedProps } from '../types';
import { useLoader } from './utils/useLoader';

export interface IFeedContainerProps extends Omit<IOffersFeedProps, 'data' | 'viewedOffers' | 'feedViewState'> {
  isSpoiler?: boolean;
}

export const FeedContainer: React.VFC<IFeedContainerProps> = ({ isSpoiler, ...rest }) => {
  const { data, isError, isFetching, isLoadMore } = useSelector(
    isSpoiler ? selectOffersHistorySpoilerData : selectOffersHistoryData,
  );
  const viewedOffers = useSelector(selectViewedOffers);
  const filtersStr = useSelector(selectFiltersStringified);
  const containerRef = React.useRef<HTMLDivElement>(null);
  const feedViewState = React.useState(false);
  const loaderHeight = useLoader(containerRef, feedViewState[0]);

  if (isError) {
    return <Error />;
  }

  if (isFetching && !isLoadMore) {
    return <Loading height={loaderHeight} />;
  }

  if (!data) {
    return null;
  }

  const { offers } = data;

  if (isEmpty(offers) && !isFetching) {
    return <EmptyData />;
  }

  return (
    <div ref={containerRef} style={{ height: '100%' }}>
      <OffersFeed {...rest} data={offers} viewedOffers={viewedOffers} feedViewState={feedViewState} key={filtersStr} />
    </div>
  );
};
